import type { AuthUser } from './auth'

const STORAGE_KEY = 'ff_admin_impersonation'

export interface ImpersonationDetails {
  id: string
  adminId: string
  adminEmail: string
  companyId: string
  companyName: string
  reason: string
  expiresAt: string
  returnTo: string
}

export interface ImpersonationSession {
  token: string
  expiresAt: number
  permissions: string[]
  viewer: AuthUser
  impersonation: ImpersonationDetails
}

export function readImpersonationSession(): ImpersonationSession | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return undefined
    const session = JSON.parse(raw) as ImpersonationSession
    if (!session.token || session.expiresAt <= Date.now() || !session.impersonation?.companyId) {
      sessionStorage.removeItem(STORAGE_KEY)
      return undefined
    }
    return session
  } catch {
    sessionStorage.removeItem(STORAGE_KEY)
    return undefined
  }
}

export function storeImpersonationSession(session: ImpersonationSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export function clearImpersonationSession(): void {
  sessionStorage.removeItem(STORAGE_KEY)
}
